import React from 'react';

import styled from 'styled-components';
import { StyledBorderedPaper } from 'styles/common';

import theme from 'constants/theme';

const MeshRecommendsPaper = ({ style, children }) => (
  <TopGradientStrippedPaper style={{ ...style }}>
    <GradientStrip />
    {children}
  </TopGradientStrippedPaper>
);

const TopGradientStrippedPaper = styled(StyledBorderedPaper)`
  border-radius: 4px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
  position: relative;
`;

const GradientStrip = styled('div')`
  background: linear-gradient(
    90deg,
    ${theme.palette.primary.main} 1.83%,
    ${theme.palette.secondary.main} 33.33%,
    ${theme.palette.red.main} 66.56%,
    ${theme.palette.green.main} 100%
  );
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 5px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
`;

export default MeshRecommendsPaper;
